module.exports = __webpack_public_path__ + "static/media/fl_cast_jbergamini.0d60b078.jpg";